



























import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import { Modal, Button } from 'ant-design-vue';
import { REMOTE_LOGIN_CONFIG } from '@/utils';

@Component({
  components: {
    AModal: Modal,
    AButton: Button,
  },
})
export default class RemoteLoginDialog extends Vue {
  @Prop({ default: false }) visible!: boolean;

  @Prop({ default: 0 }) remoteLoginCount!: number;

  private dialogVisible: boolean = false;

  get message(): string {
    if (this.remoteLoginCount > REMOTE_LOGIN_CONFIG.MAX_COUNT) {
      return REMOTE_LOGIN_CONFIG.getWarningMessageOverLimit();
    }
    return REMOTE_LOGIN_CONFIG.getWarningMessage(this.remoteLoginCount);
  }

  @Watch('visible')
  handleVisibleChange(val: boolean) {
    this.dialogVisible = val;
  }

  handleOk() {
    this.dialogVisible = false;
    this.$emit('update:visible', false);
    this.$emit('confirm');
  }
}
